<script>
  export let logo = '';

  let loading = true, error = false;
</script>

<div class="Logo">
  {#if !logo || error || loading}
    <div data-icon-before="business"></div>
  {/if}

  {#if logo && !error}
    <img src="{logo}"
         class:Loading={loading}
         alt="Account Logo"
         loading="lazy"
         on:error={() => error = true}
         on:load={() => loading = false}
    >
  {/if}
</div>

<style lang="stylus">

  .Logo {
    position relative;
    margin-right 10px;

    img, div {
      height: 65px;
      width: 110px;
      object-fit: contain;
      border-radius 3px;
      border 1px solid #ECEFF1;
      background: #ECEFF1;
      display: flex;
      justify-content: center;
      align-items: center;
    }

    div:before {
      font-size 50px;
    }

    img {
      background transparent;

      &.Loading {
        width: 0;
        height: 0;
        visibility: hidden;
      }
    }
  }
</style>
